import { speak } from '../lib/speech.js';

export default function SpeechButton({
  text,
  locale = 'en-HK',
  label = 'Play audio',
  className = '',
  children,
}) {
  return (
    <button
      className={`speech-button ${className}`.trim()}
      type="button"
      aria-label={label}
      title={label}
      onClick={(event) => {
        event.stopPropagation();
        speak(text, locale);
      }}
    >
      <span aria-hidden="true">🔊</span>
      {children}
    </button>
  );
}
